import { render, staticRenderFns } from "./ReturnPartsListView.vue?vue&type=template&id=0bd7dc2c"
import script from "./ReturnPartsListView.vue?vue&type=script&lang=js"
export * from "./ReturnPartsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bd7dc2c')) {
      api.createRecord('0bd7dc2c', component.options)
    } else {
      api.reload('0bd7dc2c', component.options)
    }
    module.hot.accept("./ReturnPartsListView.vue?vue&type=template&id=0bd7dc2c", function () {
      api.rerender('0bd7dc2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/returnparts/ReturnPartsListView.vue"
export default component.exports